exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hamburger[data-v-df96aa28] {\n    display: inline-block;\n    cursor: pointer;\n    width: 20px;\n    height: 20px;\n    transform: rotate(0deg);\n    transition: .38s;\n    transform-origin: 50% 50%;\n}\n.hamburger.is-active[data-v-df96aa28] {\n    transform: rotate(90deg);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-df96aa28","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Hamburger/index.vue
// module id = nFVA
// module chunks = 182